





























































import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
import { supervisingModule } from '../../store/modules/OperationSupervising';
@Component
export default class VariableGroup extends Vue {
  @Prop() private variableList!: any;
  private isReadMode: boolean = supervisingModule.IS_MODE_READ;
  private created() {
    let isInput: boolean = false;
    // グループ分の処理
    for (const colIndex of Object.keys(this.variableList)) {
      if (Array.isArray(this.variableList[colIndex].value)) {
        isInput = true;
        break;
      }
    }
    // 一つでも入力項目がある場合のみ配列になっていないデータの初期化を行う。
    if (isInput) {
      for (const colIndex of Object.keys(this.variableList)) {
        if (!Array.isArray(this.variableList[colIndex].value)) {
          // 配列なしの場合初期化
          this.variableList[colIndex].value = [''];
        }
        if (!Array.isArray(this.variableList[colIndex].textColor)) {
          // 配列なしの場合初期化
          this.variableList[colIndex].textColor = [''];
        }
      }
    }
  }
  /**
   * 明細行の追加
   */
  private addRow() {
    // グループ分の処理
    for (const colIndex of Object.keys(this.variableList)) {
      if (!Array.isArray(this.variableList[colIndex].value)) {
        // 配列なしの場合初期化
        this.variableList[colIndex].value = [''];
      } else {
        this.variableList[colIndex].value.push('');
      }
      //textColorの設定
      this.variableList[colIndex].textColor = [];
      for (const item of Array.from(this.variableList[colIndex].value )) {
        this.variableList[colIndex].textColor.push('');
      }
    }
  }
  /**
   * 明細行の削除
   */
  private delRow(index: number) {
    if (!confirm('対象の行を削除してよろしいですか？\n※実際のデータの削除は、登録処理を行った際になります。')) {
      return;
    }
    // グループ分の処理
    for (const colIndex of Object.keys(this.variableList)) {
      this.variableList[colIndex].value.splice(index, 1);
      //textColorの設定
      this.variableList[colIndex].textColor = [];
      for (const item of Array.from(this.variableList[colIndex].value )) {
        this.variableList[colIndex].textColor.push('');
      }
    }
  }
  @Emit('emitAddress')
  private emitAddress(address: string, target: string, index?: number) {
  }
}
